import React from 'react';
import { TwitterShareButton } from 'react-share';
import createNotification from 'components/Settings/Utilities/CreateNotification';
import { copyTextToClipboard } from 'components/Dashboard/helpers/copyFunctionality';
import preventLink from 'components/Dashboard/TagsList/prevenLink';
const ShareParliamentaryContent = (props) => {
  const { title, url, crecType } = props;
  return (
    <div
      className={`parliamentary-share-buttons ${crecType ? 'parliament-live-share-buttons border rounded-pill' : ''}`}
    >
      <button
        className={`general-button position-relative share-parliamentary-content`}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          let tempInput = document.createElement('input');
          tempInput.style = 'position: absolute; left: -1000px; top: -1000px';
          tempInput.value = url;
          document.body.appendChild(tempInput);
          tempInput.select();
          document.execCommand('copy');
          document.body.removeChild(tempInput);
          createNotification('success', `Link copied`);
        }}
        data-tooltip-id={'general-tooltip'}
        data-tooltip-content={'Copy link to this extract'}
      >
        <span className={`icon-share-link`} />
      </button>
      <TwitterShareButton
        url={url}
        title={title}
        className='share-parliamentary-content share-parliamentary-content-x'
        data-tooltip-id={'general-tooltip'}
        data-tooltip-content={'Share this extract on X'}
      >
        <span className={`icon-twitter-x-circle`} />
      </TwitterShareButton>
    </div>
  );
};

const ShareParliamentaryLiveContent = (props) => {
  const { item, additionalClass = '', children, togglePlay, isPlaying } = props;
  const { sourceUrl, contentUrl, text } = item;
  return (
    <div className={`parliamentary-share-buttons flex-centered ${additionalClass}`}>
      {togglePlay && (
        <button
          className='general-button parliament-live-play-toggle flex-centered justify-content-center specific-left-margin-6 specific-right-margin-6'
          onClick={(e) => {
            preventLink(e);
            togglePlay();
          }}
          data-tooltip-id={'general-tooltip'}
          data-tooltip-content={isPlaying ? 'Pause' : 'Play from here'}
        >
          <span className={isPlaying ? 'clip-trimmer-pause-icon' : 'clip-trimmer-play-icon'} />
        </button>
      )}
      <button
        className={`general-button position-relative share-parliamentary-content`}
        onClick={(e) => {
          preventLink(e);
          copyTextToClipboard(text);
        }}
        data-tooltip-id={'general-tooltip'}
        data-tooltip-content={'Copy text'}
      >
        <span className={`icon-copy`} />
      </button>
      <button
        className={`general-button position-relative share-parliamentary-content`}
        onClick={(e) => {
          preventLink(e);
          copyTextToClipboard(sourceUrl ?? contentUrl, 'Link copied');
        }}
        data-tooltip-id={'general-tooltip'}
        data-tooltip-content={'Copy link to parliament.tv'}
      >
        <span className={`icon-share-video title-h5-m`} />
      </button>
      {children}
    </div>
  );
};

export { ShareParliamentaryLiveContent };
export default ShareParliamentaryContent;
